/**
 * Révélation au scroll — socle d'animation partagé par les sections Zoemass.
 *
 * Usage : ajouter data-reveal sur un conteneur. Ses enfants directs portant
 * data-reveal-item apparaissent en cascade (délai piloté par --reveal-index).
 * Les styles vivent dans zoemass-brand.css.
 *
 * Ne fait rien si l'utilisateur a demandé moins d'animations : les éléments
 * sont alors marqués révélés immédiatement, sans transition.
 */
(function () {
  'use strict';

  if (window.__zoemassRevealInit) return;
  window.__zoemassRevealInit = true;

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealNow(node) {
    node.classList.add('is-revealed');
  }

  function observe(nodes) {
    if (prefersReduced || !('IntersectionObserver' in window)) {
      nodes.forEach(revealNow);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealNow(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function collect(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('[data-reveal]:not(.is-revealed)'));
  }

  function init() {
    observe(collect(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // L'éditeur de thème réinjecte des sections après coup.
  document.addEventListener('shopify:section:load', function (event) {
    observe(collect(event.target));
  });
})();
